<div class="cookies" [class.hidden]="hidden">
  <div class="content">
    <p>
      By continuing to use our site, you agree to our
      <a href="/terms-and-conditions" title="Go to Terms and conditions">
        Terms and conditions </a
      >. Learn more about how we use cookies by reviewing our
      <a href="/privacy-policy" title="Go to Privacy policy"> Privacy Policy </a
      >
    </p>

    <cve-ui-button (buttonEmit)="hideCookies()" [text]="'OK'" [size]="'S'"></cve-ui-button>
  </div>
</div>
